import script from "./RemotaSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemotaSection.vue?vue&type=script&setup=true&lang=ts"

import "./RemotaSection.vue?vue&type=style&index=0&id=017bf862&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-017bf862"]])

export default __exports__